import { render, staticRenderFns } from "./playStudyData.vue?vue&type=template&id=025e8703&scoped=true&"
import script from "./playStudyData.vue?vue&type=script&lang=ts&"
export * from "./playStudyData.vue?vue&type=script&lang=ts&"
import style0 from "./playStudyData.vue?vue&type=style&index=0&id=025e8703&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025e8703",
  null
  
)

export default component.exports